import { put, call } from 'redux-saga/effects';
import { aflt_skillSelList, aflt_keyLocationList, changePassword, currencyList, locationSearch, primaryContactList, resendEmail, getProfileRole, countryList, timeZonesList, serverTimeList, inviteAsFriend, loginAsUser } from '../services/commonService';

import * as types from '../actions'; 

export function* aflt_skillSelListSaga(payload) { 
    try {
      const response = yield call(aflt_skillSelList, payload);
      yield put({ type: types.SKILL_SEL_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SKILL_SEL_LIST_AFFILIATE_ERROR, error });
    }
}

export function* aflt_keyLocationListSaga(payload) { 
    try {
      const response = yield call(aflt_keyLocationList, payload);
      yield put({ type: types.KEY_LOC_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.KEY_LOC_LIST_AFFILIATE_ERROR, error });
    }
} 

export function* changePasswordSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER}); 
    const response = yield call(changePassword, payload);
    yield put({ type: types.CHANGE_PASSWORD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CHANGE_PASSWORD_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
} 

export function* locationSearchSaga(payload) {
  try {
    const response = yield call(locationSearch, payload);
    yield put({ type: types.MASTER_LOCATION_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.MASTER_LOCATION_LIST_ERROR, error });
  }
}

export function* currencyListSaga(payload) {
  try {
    const response = yield call(currencyList, payload);
    yield put({ type: types.LIST_CURRENCY_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.LIST_CURRENCY_ERROR, error });
  }
}

export function* primaryContactListSaga(payload) {
  try {
    const response = yield call(primaryContactList, payload);
    yield put({ type: types.LIST_PRMY_CNCT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.LIST_PRMY_CNCT_ERROR, error });
  }
}

export function* resendEmailSaga(payload) {
  try {
    const response = yield call(resendEmail, payload);
    yield put({ type: types.RESEND_EMAIL_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.RESEND_EMAIL_ERROR, error });
  }
}

export function* getProfileRoleSaga(payload) {
  try {
    const response = yield call(getProfileRole, payload);
    yield put({ type: types.PROFILE_ROLE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.PROFILE_ROLE_ERROR, error });
  }
}

export function* countryListSaga(payload) {
  try {
    const response = yield call(countryList, payload);
    yield put({ type: types.COUNTRY_LIST_SUCCESS, response })  
          
  } catch(error) {
    yield put({ type: types.COUNTRY_LIST_ERROR, error });
  }
}

export function* timeZonesListSaga(payload) {
  try {
    const response = yield call(timeZonesList, payload);
    yield put({ type: types.TIMEZONES_LIST_SUCCESS, response })  
          
  } catch(error) {
    yield put({ type: types.TIMEZONES_LIST_ERROR, error });
  }
}

export function* serverTimeListSaga(payload) {
  try {
    const response = yield call(serverTimeList, payload);
    yield put({ type: types.SERVER_TIME_LIST_SUCCESS, response })  
          
  } catch(error) {
    yield put({ type: types.SERVER_TIME_LIST_ERROR, error });
  }
}

export function* inviteAsFriendSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(inviteAsFriend, payload);
    yield put({ type: types.INVITE_AS_FRIEND_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.INVITE_AS_FRIEND_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* loginAsUserSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(loginAsUser, payload);
    yield put({ type: types.LOGIN_AS_USER_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.LOGIN_AS_USER_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}



